module.exports = __webpack_public_path__ + "static/CommonWealth-b93d1c07f24cf8c690aaa76fc275df11.png";